import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import LoaderButton from "../Common/LoaderButton";
import SmallLoaderButton from "../Common/SmallLoaderButton";

const DeleteMeetingModal = React.memo((props) => {
  const handleSubmit = () => {
    if (props.handleSubmit) {
      props.handleSubmit();
    }
  };

  const closeModal = () => {
    props.setIsModalOpen(false);
  };

  return (
    <Modal show={props.isModalOpen} onHide={closeModal} backdrop="static">
      <div className="modal-header">
        <h4 className="modal-title">Delete Meeting</h4>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={closeModal}
        ></button>
      </div>

      <div className="modal-body delete-txt">
        <h6>Are you sure you want to delete this meeting?</h6>
      </div>

      <div className="modal-footer">
        <Button variant="" className="add-minutes Mom-btn" onClick={closeModal}>
          <p>No</p>
        </Button>
        {props?.isLoading ? (
          <SmallLoaderButton />
        ) : (
          <Button
            variant=""
            className="create-meeting-button Mom-btn btn"
            onClick={handleSubmit}
          >
            <p>Yes</p>
          </Button>
        )}
      </div>
    </Modal>
  );
});

export default DeleteMeetingModal;
